import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Table = React.forwardRef(
    (
        {
            borderlessRow = false,
            children,
            className,
            hoverable = true,
            compact = false,
            asElement: Component = 'table',
            ...rest
        },
        ref,
    ) => {
        const tableClass = classNames(
            Component === 'table' ? 'table-default' : 'table-flex',
            hoverable && 'table-hover',
            compact && 'table-compact',
            borderlessRow && 'borderless-row',
            className,
        )

        return (
            <div className="table-overflow">
                <Component className={tableClass} {...rest} ref={ref}>
                    {children}
                </Component>
            </div>
        )
    },
)

Table.propTypes = {
    hoverable: PropTypes.bool,
    compact: PropTypes.bool,
    asElement: PropTypes.string,
    borderlessRow: PropTypes.bool,
}

export default Table
